

import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const ServicesSection = () => {

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {

    const style = document.createElement("style");

    style.innerHTML = `

    .services-section{
      padding:70px 20px;
      background:#f5f5f5;
    }

    .services-container{
      max-width:1300px;
      margin:auto;
    }

    .services-heading{
      text-align:center;
      font-size:42px;
      font-weight:700;
      color:#0b3c5d;
      margin-bottom:50px;
    }

    .services-grid{
      display:grid;
      grid-template-columns:repeat(auto-fit,minmax(370px,1fr));
      gap:28px;
    }

    .service-card{
      background:#fff;
      border-radius:20px;
      padding:18px;
      display:flex;
      align-items:flex-start;
      gap:20px;
      cursor:pointer;
      transition:0.3s ease;
      box-shadow:0 3px 12px rgba(0,0,0,0.08);
    }

    .service-card:hover{
      transform:translateY(-8px);
      box-shadow:0 10px 20px rgba(0,0,0,0.14);
    }

    .service-card img{
      width:180px;
      height:140px;
      border-radius:16px;
      object-fit:cover;
      flex-shrink:0;
    }

    .service-content{
      flex:1;
    }

    .service-title{
      font-size:24px;
      font-weight:700;
      color:#0b3c5d;
      margin-bottom:12px;
      line-height:1.3;
    }

    .service-desc{
      font-size:15px;
      color:#444;
      line-height:1.7;
    }

    @media(max-width:768px){

      .services-grid{
        grid-template-columns:1fr;
      }

      .service-card{
        flex-direction:column;
      }

      .service-card img{
        width:100%;
        height:220px;
      }

      .services-heading{
        font-size:34px;
      }
    }

    `;

    document.head.appendChild(style);

  }, []);

  // =====================================================
  // PAGE WISE SPECIALITIES
  // =====================================================

  const servicesData = {

    // ================= PROCTOLOGY =================

    "/proctology": {
      heading: "Our Proctology Specialities",

      services: [

        {
          title: "Piles",
          image: "https://www.shutterstock.com/image-photo/man-suffering-hemorrhoid-living-room-260nw-1634784697.jpg",
          desc:
            "Get relief from painful piles with advanced laser treatment.Minimally invasive, no stitches, same-day discharge…",
          link: "/piles"
        },

        {
          title: "Anal Fissure",
          image:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTObU9Q-SbcKV7-5ofrN5dAkVcqpJOn5s42Ew&s",
          desc:
            "Advanced fissure treatment with minimal pain and expert care.",
          link: "/fissure"
        },

        {
          title: "Anal Fistula",
          image:
            "https://drvaidji.com/cdn/shop/articles/fa5.jpg?v=1694254756",
          desc:
            "Safe and advanced fistula treatment procedures.",
          link: "/fistula"
        },

        

      ]
    },

    // ================= LAPAROSCOPY =================

    "/laparoscopy": {
      heading: "Our Laparoscopy Specialities",

      services: [

        {
          title: "Femoral Hernia",
          image:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSCIC-24G8sjbHfVCzGfz_HTCl6kVEIlQNviw&s",
          desc:
            "Protrusion of internal organs into abdominal muscle wall ",
          link: "/femoral-hernia"
        },

        {
          title: "Incisional Hernia",
          image:
            "https://assets.yourpractice.online/2268/3d-images/incisional-hernia.jpg",
          desc:
            "Heal painful anal fissures with advanced, non-surgical care.Quick relief, minimal downtime, expert proctology support",
          link: "/incisional-hernia"
        },

        {
          title: "Hiatal Hernia",
          image:
            "https://www.drmayank.com/images/service/haitus2.jpg",
          desc:
            "Safe laparoscopic procedures with expert surgeons.",
          link: "/hiatal-hernia"
        },

        {
          title: "Appendicitis",
          image:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQeL9KFqcztKZOBJVN_SndxNPhY86K_sg2-tA&s",
          desc:
            "Get permanent relief from pilonidal sinus with laser surgery.Painless procedure, quick healing, same-day discharge",
          link: "/appendicitis"
        },

        {
          title: "Umbilical Hernia",
          image:
            "https://i0.wp.com/post.medicalnewstoday.com/wp-content/uploads/sites/3/2022/02/1_shutterstock_1794789001.jpg?w=1155",
          desc:
            "Advanced treatment for rectal prolapse by expert surgeons.Safe procedure, minimal pain, long-term relief.",
          link: "/umbilical-hernia"
        },

        {
          title: "Inguinal Hernia",
          image:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQm5Y8XBBF9zZFFppOJopAkaGxP8sJ1jPndMw&s",
          desc:
            "Advanced treatment for rectal prolapse by expert surgeons.Safe procedure, minimal pain, long-term relief.",
          link: "/inguinal-hernia"
        }

      ]
    },

    // ================= UROLOGY =================

    "/urology": {
      heading: "Our Urology Specialities",

      services: [
{
          title: "Stapler Circumcision",
          image:
            "https://5.imimg.com/data5/SELLER/Default/2024/11/469023489/IB/FN/SJ/24309784/stapler-1-500x500.jpg",
          desc:
            "a minimally invasive, 10–20 minute outpatient procedure using a specialized device to cut and seal the foreskin simultaneously",
          link: "/phimosis"
        },
        {
          title: "Laser Circumcision",
          image:
            "https://www.eleganceclinic.in/wp-content/uploads/2024/09/Laser-Circumcision-Surgery-1.webp",
          desc:
            "Painless laser circumcision with quick recovery.",
          link: "/laser-circumcision"
        },

        {
          title: "Circumcision",
          image:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRckkPSn2eyWfAspZGtmNDfDbnTLZWyfQVilw&s",
          desc:
            "Safe circumcision procedures with expert doctors.",
          link: "/circumcision"
        },

        

        {
          title: "Hydrocele",
          image:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQjjNYJcnxZuqn2FqBavs4aioQJEDhaoLEibw&s",
          desc:
            "Safe hydrocele surgery with faster recovery.",
          link: "/hydrocele"
        }

      ]
    },

    // ================= AESTHETICS =================

    "/aesthetics": {
      heading: "Our Aesthetics Specialities",

      services: [

        {
          title: "Gynecomastia",
          image:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQzPwcqvQPKkkrAtVq-Puyl8RG96izcfFMNxQ&s",
          desc:
            "man boobs or enlarged breasts, is a condition in which breast tissues start to develop in males due to hormonal imbalance or higher levels of estrogen.",
          link: "/Gynecomastia"
        },

        

        {
          title: "Lipoma",
          image:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcScwQXPmFWOY0frj0HQPVXS_JNlHMuN_l48KA&s",
          desc:
            "A lipoma is a soft, benign lump made up of fatty tissue that grows slowly under the skin and is usually painless and harmless.",
          link: "/lipoma"
        }

      ]
    },

    // ================= ENT =================

    "/ent": {
      heading: "Our ENT Specialities",

      services: [

        


        {
          title: "Mastoidectomy",
          image:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRCimcVwVj8Tv7C-GLDFleW7vnTkEotFq5ebQ&s",
          desc:
            "Minimally invasive sinus surgery procedures.",
          link: "/Mastoidectomy"
        },

        {
          title: "Thyroidectomy",
          image:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRO2rJaom72yGhD_b6n1JDgUry4pC3VXF-rFg&s",
          desc:
            "Expert thyroid gland surgery and care.",
          link: "/thyroidectomy"
        }

      ]
    },

    // ================= FERTILITY =================

    "/fertility": {
      heading: "Our Fertility Specialities",

      services: [

        {
          title: "IVF Treatment",
          image:
            "https://drankitasfertilitycenter.com/blog/wp-content/uploads/2024/10/ivf-process-1024x1024-1.jpg",
          desc:
            "IVF is a fertility treatment where eggs and sperm are combined in a lab to create embryos, which are then transferred to the uterus for pregnancy.",
          link: "/ivf-treatment"
        },

        {
          title: "IUI Treatment",
          image:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSFzyDdr5pTZKmHxQ-Ch3XAkRusw1UM0yzr6A&s",
          desc:
            "IUI (Intrauterine Insemination) is a fertility treatment where washed sperm is directly placed into the uterus to increase chances of pregnancy.",
          link: "/iui-treatment"
        },

        {
          title: "Egg Freezing",
          image:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQXJH37uZqzV90gn0jINZtrJcWn6Th1RkHb4w&s",
          desc:
            "Egg freezing is a procedure where a woman’s eggs are collected, frozen, and stored to preserve fertility for future use.",
          link: "/egg-freezing"
        }

      ]
    }

  };

  // =====================================================
  // SHOW SAME SPECIALITIES FOR SUB PAGES ALSO
  // =====================================================

  const currentPath = location.pathname.toLowerCase();

  const currentPage =

    (
      currentPath.includes("/proctology") ||
      currentPath.includes("/piles") ||
      currentPath.includes("/fissure") ||
      currentPath.includes("/fistula") ||
      currentPath.includes("/pilonidal") ||
      currentPath.includes("/rectal-prolapse")
    )
      ? servicesData["/proctology"]

    : (
      currentPath.includes("/laparoscopy") ||
      currentPath.includes("/femoral-hernia") ||
      currentPath.includes("/incisional-hernia") ||
      currentPath.includes("/hiatal-hernia") ||
      currentPath.includes("/appendicitis") ||
      currentPath.includes("/umbilical-hernia") ||
      currentPath.includes("/inguinal-hernia")
    )
      ? servicesData["/laparoscopy"]

    : (
      currentPath.includes("/urology") ||
      currentPath.includes("/laser-circumcision") ||
      currentPath.includes("/circumcision") ||
      currentPath.includes("/phimosis") ||
      currentPath.includes("/hydrocele")
    )
      ? servicesData["/urology"]

    : (
      currentPath.includes("/aesthetics") ||
      currentPath.includes("/hair-transplant") ||
      currentPath.includes("/beard-transplant") ||
      currentPath.includes("/liposuction")
    )
      ? servicesData["/aesthetics"]

    : (
      currentPath.includes("/ent") ||
      currentPath.includes("/sinus-treatment") ||
      currentPath.includes("/fess-surgery") ||
      currentPath.includes("/thyroidectomy")
    )
      ? servicesData["/ent"]

    : (
      currentPath.includes("/fertility") ||
      currentPath.includes("/ivf-treatment") ||
      currentPath.includes("/iui-treatment") ||
      currentPath.includes("/egg-freezing")
    )
      ? servicesData["/fertility"]

    : null;

  if (!currentPage) return null;

  return (

    <section className="services-section">

      <div className="services-container">

        <h2 className="services-heading">
          {currentPage.heading}
        </h2>

        <div className="services-grid">

          {currentPage.services.map((item, index) => (

            <div
              className="service-card"
              key={index}
              onClick={() => navigate(item.link)}
            >

              <img
                src={item.image}
                alt={item.title}
              />

              <div className="service-content">

                <div className="service-title">
                  {item.title}
                </div>

                <div className="service-desc">
                  {item.desc}
                </div>

              </div>

            </div>

          ))}

        </div>

      </div>

    </section>

  );
};

export default ServicesSection;